export const breakpointXs = 0;
export const breakpointSm = 576;
export const breakpointMd = 768;
export const breakpointLg = 992;
export const breakpointXl = 1200;
